import type { CampaignType, CampaignRecipientType } from 'types/campaignTypes';

export const recipientsMockData: CampaignRecipientType[] = [
  {
    id: 0,
    category: 'group',
    group: 'all',
    name: 'All Subscribers',
    email: null,
    count: 12450,
  },
  {
    id: 0,
    category: 'group',
    group: 'premium',
    name: 'Premium Members',
    email: null,
    count: 3210,
  },
  {
    id: 0,
    category: 'group',
    group: 'new',
    name: 'New Customers',
    email: null,
    count: 890,
  },
  {
    id: 1,
    category: 'user',
    group: null,
    name: 'Kristina Mayer',
    email: 'kristina-mayer@example.com',
    count: 1,
  },
  {
    id: 2,
    category: 'user',
    group: null,
    name: 'Mike Mayer',
    email: 'mike-mayer@example.com',
    count: 1,
  },
  {
    id: 3,
    category: 'user',
    group: null,
    name: 'Alice Johnson',
    email: 'alice-johnson@example.com',
    count: 1,
  },
  {
    id: 4,
    category: 'user',
    group: null,
    name: 'Bob Brown',
    email: 'bob-brown@example.com',
    count: 1,
  },
  {
    id: 5,
    category: 'user',
    group: null,
    name: 'Charlie White',
    email: 'charlie-white@example.com',
    count: 1,
  },
  {
    id: 6,
    category: 'user',
    group: null,
    name: 'Diana Green',
    email: 'diana-green@example.com',
    count: 1,
  },
  {
    id: 7,
    category: 'user',
    group: null,
    name: 'Ethan Black',
    email: 'ethan-black@example.com',
    count: 1,
  },
];

export const campaignsMockData: CampaignType[] = [{
  id: 1,
  name: 'Campaign 1',
  channel: 'sms',
  subject: 'Subject 1',
  message: 'Hi',
  status: 'sent',
  // isShouldBeRetry: true,
  // isRetryCompleted: false,
  // owner: {
  //   id: 1,
  //   name: 'Kristina Mayer',
  //   email: 'kristina-mayer@example.com',
  // },
  scheduledAt: '2025-07-06T04:00:00.000Z',
  // createdAt: '2025-07-04T04:00:00.000Z',
  // updatedAt: '2025-07-04T04:00:00.000Z',
  recipients: [
    {
      id: 0,
      category: 'group',
      group: 'all',
      name: 'All Subscribers',
      email: null,
      count: 12450,
    },
  ],
}, {
  id: 2,
  name: 'Campaign 2',
  channel: 'email',
  subject: 'Subject 2',
  message: 'Hi',
  status: 'queued',
  // isShouldBeRetry: true,
  // isRetryCompleted: false,
  // owner: {
  //   id: 1,
  //   name: 'Kristina Mayer',
  //   email: 'kristina-mayer@example.com',
  // },
  scheduledAt: '2025-07-10T05:00:00.000Z',
  // createdAt: '2025-07-04T04:00:00.000Z',
  // updatedAt: '2025-07-04T04:00:00.000Z',
  recipients: [
    {
      id: 0,
      category: 'group',
      group: 'premium',
      name: 'Premium Members',
      email: null,
      count: 3210,
    },
  ],
}, {
  id: 3,
  name: 'Campaign 3',
  channel: 'all',
  subject: 'Subject 3',
  message: 'Hi',
  status: 'queued',
  // isShouldBeRetry: true,
  // isRetryCompleted: false,
  // owner: {
  //   id: 1,
  //   name: 'Kristina Mayer',
  //   email: 'kristina-mayer@example.com',
  // },
  scheduledAt: '2025-07-10T09:00:00.000Z',
  // createdAt: '2025-07-04T04:00:00.000Z',
  // updatedAt: '2025-07-04T04:00:00.000Z',
  recipients: [
    {
      id: 0,
      category: 'group',
      group: 'new',
      name: 'New Customers',
      email: null,
      count: 890,
    },
  ],
}, {
  id: 4,
  name: 'Campaign 4',
  channel: 'sms',
  subject: 'Subject 4',
  message: 'Hi',
  status: 'queued',
  // isShouldBeRetry: true,
  // isRetryCompleted: false,
  // owner: {
  //   id: 1,
  //   name: 'Kristina Mayer',
  //   email: 'kristina-mayer@example.com',
  // },
  scheduledAt: '2025-07-11T09:00:00.000Z',
  // createdAt: '2025-07-04T04:00:00.000Z',
  // updatedAt: '2025-07-04T04:00:00.000Z',
  recipients: [
    {
      id: 0,
      category: 'group',
      group: 'new',
      name: 'New Customers',
      email: null,
      count: 890,
    },
    {
      id: 2,
      category: 'user',
      group: null,
      name: 'Mike Mayer',
      email: 'mike-mayer@example.com',
      count: 1,
    },
    {
      id: 3,
      category: 'user',
      group: null,
      name: 'Alice Johnson',
      email: 'alice-johnson@example.com',
      count: 1,
    },
    {
      id: 4,
      category: 'user',
      group: null,
      name: 'Bob Brown',
      email: 'bob-brown@example.com',
      count: 1,
    },
  ],
}];

export const upcomingCampaignsMockData: CampaignType[] = (() => {
  return campaignsMockData.filter((campaign) => {
    const campaignDate = new Date(campaign.scheduledAt);
    return campaignDate > new Date();
  });
})();

export const CHANNEL_COLORS = {
  sms: '#48bb78',
  email: '#4299e1',
  all: '#45aaad',
};

export const CHANNEL_LABELS = {
  sms: 'SMS',
  email: 'Email',
  all: 'SMS & Email',
};
